module.exports = __webpack_public_path__ + "quiz_static/img/sad.3e8756bf.png";